import { render } from "./TutorDashboard.vue?vue&type=template&id=02c90403&scoped=true"
import script from "./TutorDashboard.vue?vue&type=script&lang=js"
export * from "./TutorDashboard.vue?vue&type=script&lang=js"

import "./TutorDashboard.vue?vue&type=style&index=0&id=02c90403&lang=scss&scoped=true"
import "./TutorDashboard.vue?vue&type=style&index=1&id=02c90403&lang=css"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c90403"]])

export default __exports__